/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import AppComponent from './AppComponent';

class PrivateRoute extends AppComponent {
  renderRoute = (Component, user) => props => {
    if (user) {
      return <Component {...props} />;
    }
    return (
      <Redirect to={{
        pathname: '/login',
        state: { from: props.location },
      }}
      />
    );
  };

  render() {
    const { component: Component, ...rest } = this.props;
    const { user } = this.app;
    return (
      <Route
        {...rest}
        render={this.renderRoute(Component, user)}
      />
    );
  }
}

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/core/PrivateRoute.js